/*@ngInject*/
const CreateCorrespondenceEmailRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.createCorrespondenceEmail = function (submissionId) {
        let url = '/rest/Email/createCorrespondenceEmail',
            config = {
                params: {
                    submissionId: submissionId
                }
            };

        return this.post(url, {}, config);
    };
};

angular.module('gw-um-submission')
    .service('createCorrespondenceEmailRepository', CreateCorrespondenceEmailRepository);
